import { createFileRoute, Link } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { Button } from "@/components/ui/button"
import { IndividualDBSChecks } from "@/features/individuals/components/individual-dbs-checks"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/"
)({
  staticData: { attention: "individual.dbs" },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      individualQueries.dbsChecks(params.individualId)
    ),
  component: IndividualChecksPage,
})

function IndividualChecksPage() {
  const { individualId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="DBS checks"
        actions={
          <Button
            nativeButton={false}
            render={
              <Link
                from="/$organisation"
                to="/$organisation/individuals/$individualId/checks/edit"
                params={{ individualId }}
              >
                Update checks
              </Link>
            }
          />
        }
      />

      <PageContent>
        <IndividualDBSChecks individualId={individualId} />
      </PageContent>
    </>
  )
}
